module.exports = __webpack_public_path__ + "static/img/Alarma.13fa6553.png";